import { Injectable } from '@angular/core';
import { Router, Params, RouterEvent, NavigationEnd, ActivatedRoute as NgActivatedRoute, Data } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActivatedRoute {

	route: Observable<NgActivatedRoute>;
	params: Observable<Params>;
	query: Observable<Params>;
	data: Observable<Data>;
	fragment: Observable<string>;

	constructor(private router: Router,
				private activatedRoute: NgActivatedRoute) { 

		this.route = this.router.events.pipe(
						filter((event: RouterEvent) => event instanceof NavigationEnd),
						map(() => this.activatedRoute),
						map((route: NgActivatedRoute) => {
							while (route.firstChild) route = route.firstChild;
							return route;
						}),
						filter((route: NgActivatedRoute) => route.outlet === 'primary')
					);

		this.fragment = this.route.pipe(switchMap(route => route.fragment), distinctUntilChanged());
		this.params = this.route.pipe(switchMap(route => route.params), distinctUntilChanged());
		this.data = this.route.pipe(switchMap(route => route.data), distinctUntilChanged());
		this.query = this.route.pipe(switchMap(route => route.queryParams), distinctUntilChanged());
	}
}
